import { Outlet, Route } from 'react-router-dom';
import { Navigate } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import queryString from 'query-string';
import { LayoutCabinet } from 'components/layout';
import CabinetPage from '../pages/cabinet';
import {
  AccountsPage,
  AddAccountPage,
  AddCreativeTextPage,
  AddFlowPage,
  AddGoToTestPage,
  AdsHistoryPage,
  CreativeTextsPageFB,
  EditCreativeTextPage,
  EditGoToTestPage,
  FacebookSheetsPage,
  FlowsPage,
  GoToTestPage,
  OverviewDashboardPage,
} from '../pages/cabinet/facebook';
import { ProtectedRoute } from 'features/login';
import EditFlowPage from '../pages/cabinet/facebook/EditFlowPage';
import EditAccountPage from '../pages/cabinet/facebook/EditAccountPage';
import AddFacebookPagePage from '../pages/cabinet/facebook/AddFacebookPagePage';
import EditFacebookPagesPage from '../pages/cabinet/facebook/EditFacebookPagesPage';
import UsersPage from '../pages/cabinet/facebook/UsersPage';
import EditUserPage from '../pages/cabinet/facebook/EditUserPage';
import {
  AddCreativeTextPageTT,
  AddFlowPageTT,
  AddGoToTestPageTT,
  AdsHistoryPageTT,
  CreativeTextsPageTT,
  EditCreativeTextPageTT,
  EditFlowPageTT,
  EditGoToTestPageTT,
  FlowsPageTT,
  GoToTestPageTT,
} from '../pages/cabinet/tiktok';

const CabinetRouter = (
  <Route path="/cabinet">
    <Route index element={<Navigate to="overview" />} />
    <Route
      path={''}
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <LayoutCabinet title="Facebook Cabinet">
            <CabinetPage />
          </LayoutCabinet>
        </QueryParamProvider>
      }
    >
      <Route path={''} element={<Navigate to="overview" />} />
      <Route index path={'overview'} element={<OverviewDashboardPage />} />
    </Route>
    <Route
      path={'facebook'}
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <LayoutCabinet title="Facebook Cabinet">
            <CabinetPage />
          </LayoutCabinet>
        </QueryParamProvider>
      }
    >
      <Route path={''} element={<Navigate to="ads-history" />} />
      <Route path={'ads-history'} element={<AdsHistoryPage />} />
      <Route path={'flows'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={
            <ProtectedRoute path="/flows">
              <FlowsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/flows">
              <AddFlowPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={':flowId'}
          element={
            <ProtectedRoute path="/flows">
              <EditFlowPage />
            </ProtectedRoute>
          }
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
      <Route path={'creative-texts'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={
            <ProtectedRoute path="/creative-texts">
              <CreativeTextsPageFB />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/creative-texts">
              <AddCreativeTextPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={':textId'}
          element={
            <ProtectedRoute path="/creative-texts">
              <EditCreativeTextPage />
            </ProtectedRoute>
          }
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
      <Route path={'accounts'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={
            <ProtectedRoute path="/accounts">
              <AccountsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/accounts">
              <AddAccountPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={':accountId'}
          element={
            <ProtectedRoute path="/accounts">
              <EditAccountPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path={'facebook-pages'} element={<Outlet />}>
        <Route
          path={''}
          element={
            <ProtectedRoute path="/facebook-pages">
              <FacebookSheetsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/facebook-pages">
              <AddFacebookPagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path={':facebookId'}
          element={
            <ProtectedRoute path="/facebook-pages">
              <EditFacebookPagesPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path={'go-to-test'} element={<Outlet />}>
        <Route
          path={''}
          element={
            <ProtectedRoute path="/go-to-test">
              <GoToTestPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/go-to-test">
              <AddGoToTestPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={':goToTestId'}
          element={
            <ProtectedRoute path="/go-to-test">
              <EditGoToTestPage />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path={'users'} element={<Outlet />}>
        <Route
          path={''}
          element={
            <ProtectedRoute path="/users">
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={':userId'}
          element={
            <ProtectedRoute path="/users">
              <EditUserPage />
            </ProtectedRoute>
          }
        />
      </Route>
    </Route>

    <Route
      path={'tiktok'}
      element={
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: (str) =>
              queryString.parse(str, { arrayFormat: 'comma' }),
            objectToSearchString: (input) =>
              queryString.stringify(input, { arrayFormat: 'comma' }),
          }}
        >
          <LayoutCabinet title="TikTok Cabinet">
            <CabinetPage />
          </LayoutCabinet>
        </QueryParamProvider>
      }
    >

      <Route path={''} element={<Navigate to="creative-texts" />} />
      <Route path={'ads-history'} element={<AdsHistoryPageTT />} />
      <Route path={'creative-texts'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={
            <ProtectedRoute path="/creative-texts">
              <CreativeTextsPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/creative-texts">
              <AddCreativeTextPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={':textId'}
          element={
            <ProtectedRoute path="/creative-texts">
              <EditCreativeTextPageTT />
            </ProtectedRoute>
          }
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
      <Route path={'flows'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={
            <ProtectedRoute path="/flows">
              <FlowsPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/flows">
              <AddFlowPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={':flowId'}
          element={
            <ProtectedRoute path="/flows">
              <EditFlowPageTT />
            </ProtectedRoute>
          }
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
      <Route path={'go-to-test'} element={<Outlet />}>
        <Route
          index
          path={''}
          element={
            <ProtectedRoute path="/go-to-test">
              <GoToTestPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={'add'}
          element={
            <ProtectedRoute path="/go-to-test">
              <AddGoToTestPageTT />
            </ProtectedRoute>
          }
        />
        <Route
          path={':goToTestId'}
          element={
            <ProtectedRoute path="/go-to-test">
              <EditGoToTestPageTT />
            </ProtectedRoute>
          }
        />
        <Route path={'*'} element={<Navigate to="" />} />
      </Route>
    </Route>
  </Route>
);

export default CabinetRouter;